import react from "react";
import './style.less'
import {OverPack} from 'rc-scroll-anim';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import { Col } from "antd"; 
import { enquireScreen } from 'enquire-js';

let isMobile;
enquireScreen((b) => {
    isMobile = b;
});
export default class TextContent extends react.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return !isMobile?(
            <div>
                <OverPack className="text-content">
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                        <QueueAnim key="queue" leaveReverse>
                            <div key="a" className="code-box-shape queue-anim-demo">
                                <span>精致 </span>的飞机造型,
                            </div>
                            <div key="a" className="code-box-shape queue-anim-demo">
                                <span>逼真 </span>的物理效果.
                            </div>
                        </QueueAnim>
                    </Col>
                </OverPack>
                <OverPack className="text-content">
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                        <QueueAnim key="queue" leaveReverse>
                            <div key="b" className="code-box-shape queue-anim-demo">
                                完全自主
                            </div>
                            <div key="b" className="code-box-shape queue-anim-demo">
                                <span>超视距 </span>范围的飞行
                            </div>
                        </QueueAnim>
                    </Col>
                </OverPack>
                <OverPack className="text-content">
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                        <QueueAnim key="queue" leaveReverse>
                            <div key="c" className="code-box-shape queue-anim-demo">
                                <span>强大 </span>的飞控算法,
                            </div>
                            <div key="c" className="code-box-shape queue-anim-demo">
                                完美 <span>适配 </span>不同型号.
                            </div>
                        </QueueAnim>
                    </Col>
                </OverPack>
                <OverPack className="text-content">
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                        <QueueAnim key="queue" leaveReverse>
                            <div key="d" className="code-box-shape queue-anim-demo">
                                <span>全自动 </span>起降，任务航线规划，应急保护等,
                            </div>
                            <div key="d" className="code-box-shape queue-anim-demo">
                                任务路线飞行,
                            </div>
                            <div key="d" className="code-box-shape queue-anim-demo">
                                详细的飞行环境 <span>模拟.</span>
                            </div>
                        </QueueAnim>
                    </Col>
                </OverPack>
                <OverPack className="text-content">
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                        <QueueAnim key="queue" leaveReverse>
                            <div key="e" className="code-box-shape queue-anim-demo">
                                <span>简单 </span>的安装使用过程,<br/>
                            </div>
                            <div key="e" className="code-box-shape queue-anim-demo">
                                快速上手体验飞行的 <span>乐趣 </span>
                            </div>
                        </QueueAnim>
                    </Col>
                </OverPack>
                <OverPack className="text-content">
                    <Col xs={24} sm={24} md={12} lg={24} xl={24}>
                        <TweenOne key="0" animation={{opacity: 1}}
                                  className="simulator-img"
                                  style={{opacity: 0, marginBottom: 10}}
                        />
                    </Col>
                </OverPack>
            </div>
        ): (
            <div>
                <OverPack className="text-content">
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                            <QueueAnim key="queue" leaveReverse>
                                <div key="a" className="code-box-shape queue-anim-demo">
                                    <span>精致 </span>的飞机造型,
                                </div>
                                <div key="a" className="code-box-shape queue-anim-demo">
                                    <span>逼真 </span>的物理效果.
                                </div>
                        </QueueAnim>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                            <QueueAnim key="queue" leaveReverse>
                                <div key="c" className="code-box-shape queue-anim-demo">
                                    <span>强大 </span>的飞控算法,
                                </div>
                                <div key="c" className="code-box-shape queue-anim-demo">
                                    完美 <span>适配 </span>不同型号.
                                </div>
                        </QueueAnim>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                            <QueueAnim key="queue" leaveReverse>
                                <div key="c" className="code-box-shape queue-anim-demo">
                                    <span>强大 </span>的飞控算法,
                                </div>
                                <div key="c" className="code-box-shape queue-anim-demo">
                                    完美 <span>适配 </span>不同型号.
                                </div>
                        </QueueAnim>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                            <QueueAnim key="queue" leaveReverse>
                                <div key="d" className="code-box-shape queue-anim-demo">
                                    <span>全自动 </span>起降，任务航线规划，应急保护等,
                                </div>
                                <div key="d" className="code-box-shape queue-anim-demo">
                                    任务路线飞行,
                                </div>
                                <div key="d" className="code-box-shape queue-anim-demo">
                                    详细的飞行环境 <span>模拟.</span>
                                </div>
                        </QueueAnim>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12} xl={24}>
                            <QueueAnim key="queue" leaveReverse>
                                <div key="e" className="code-box-shape queue-anim-demo">
                                    <span>简单 </span>的安装使用过程,<br />
                                </div>
                                <div key="e" className="code-box-shape queue-anim-demo">
                                    快速上手体验飞行的 <span>乐趣 </span>
                                </div>
                        </QueueAnim>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={24} xl={24}>
                        <TweenOne key="0" animation={{ opacity: 1 }}
                            className="simulator-img"
                            style={{ opacity: 0, marginBottom: 10 }}
                        />
                    </Col>
                </OverPack>
            </div>
        )
    }
}
